import { useState } from "react";
import { NumberInput, NumberInputProps } from "@mantine/core";

type TCRNumberInputProps = Omit<
  NumberInputProps,
  "onChange" | "onBlur" | "value"
> & {
  value: number;
  onChange: (value: number) => void;
  minValue?: number;
  maxValue?: number;
  defaultValue?: number;
};

/**
 * Универсальный компонент для ввода CR (Conversion Rate) значений
 * Обрабатывает валидацию и корректировку значений при потере фокуса
 */
export const CRNumberInput = ({
  value,
  onChange,
  minValue = 10,
  maxValue = 100,
  defaultValue = 100,
  ...props
}: TCRNumberInputProps) => {
  const [tempValue, setTempValue] = useState<string | number | null>(null);

  const handleChange = (val: string | number) => {
    // Просто сохраняем временное значение
    setTempValue(val);
  };

  const handleBlur = () => {
    // Получаем текущее значение
    const currentValue = tempValue !== null ? Number(tempValue) : value;
    let correctedValue = currentValue;

    // Если поле пустое или равно 0, устанавливаем значение по умолчанию
    if (!currentValue || currentValue === 0) {
      correctedValue = defaultValue;
    }
    // Проверяем и корректируем значение
    else if (currentValue < minValue) {
      correctedValue = minValue;
    } else if (currentValue > maxValue) {
      correctedValue = maxValue;
    }

    // Очищаем временное значение
    setTempValue(null);

    // Применяем скорректированное значение, если оно изменилось
    if (correctedValue !== value) {
      onChange(correctedValue);
    }
  };

  return (
    <NumberInput
      {...props}
      value={tempValue !== null ? tempValue : value}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

